import Vue from "vue";
import Vuex from "vuex";

// 模块
import company from "./modules/company"; // 公司
import user from "./modules/user"; // 公司
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        systemType: window.platDataMap.name
    },
    getters: {
        systemConfig: (state) => window.platDataMap[state.systemType] || {},
        systemTitle: (state) => window.platDataMap[state.systemType].title
    },
    mutations: {},
    actions: {
        // 分发更新数据 当前user, updateAuthtoken, company
        setInfo ({ commit }, info) {
            info = info || {};
            commit("updateUserData", info.user || {});
            commit("updateAuthtoken", info.authtoken || "");
            commit("updateDefaultComp", info.company);
            commit("updateCompany", {});
        }
    },
    modules: {
        user,
        company
    }
});



// WEBPACK FOOTER //
// ./src/store/index.js